import { DefaultTableParameters } from '@benzinga/ag-grid-utils';
import { WatchlistWidgetIteration, WatchlistWidgetAllIterations } from './entities';
import { LoaderConvertor, WidgetSettingsLoaderFromLoader } from '@benzinga/widget-tools';

export const WatchlistWidgetMigrator = async (
  configs: LoaderConvertor<WatchlistWidgetAllIterations>,
): Promise<WidgetSettingsLoaderFromLoader<WatchlistWidgetIteration>> => {
  switch (configs.version) {
    case 1: {
      return WatchlistWidgetMigrator({
        ...configs,
        version: 2,
        widgets: configs.widgets.map(widget => ({
          ...widget,
          parameters: {
            flightMode: false,
            table: widget.parameters.table,
            watchlistId: null,
          },
        })),
      });
    }
    case 2:
      return WatchlistWidgetMigrator({
        ...configs,
        version: 3,
        widgets: configs.widgets.map(widget => ({
          ...widget,
          parameters: {
            ...widget.parameters,
            sendGroup: null,
          },
        })),
      });
    case 3:
      return WatchlistWidgetMigrator({
        ...configs,
        globalSettings: { enableTickerAutoselect: false },
        version: 4,
      });
    default:
      return {
        ...configs,
        widgets: configs.widgets.map(widget => ({
          ...widget,
          parameters: {
            ...widget.parameters,
            table: widget.parameters.table ?? DefaultTableParameters,
          },
        })),
      };
  }
};
